import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage106 from "../../../../assets/PDFViewerImages/PDFViewerImage106.jpg";
import PDFViewerImage107 from "../../../../assets/PDFViewerImages/PDFViewerImage107.jpg";
import PDFViewerImage108 from "../../../../assets/PDFViewerImages/PDFViewerImage108.jpg";
import PDFViewerImage109 from "../../../../assets/PDFViewerImages/PDFViewerImage109.jpg";
import PDFViewerImage110 from "../../../../assets/PDFViewerImages/PDFViewerImage110.jpg";
import PDFViewerImage111 from "../../../../assets/PDFViewerImages/PDFViewerImage111.jpg";
import PDFViewerImage112 from "../../../../assets/PDFViewerImages/PDFViewerImage112.jpg";
import PDFViewerImage113 from "../../../../assets/PDFViewerImages/PDFViewerImage113.jpg";
import PDFViewerImage114 from "../../../../assets/PDFViewerImages/PDFViewerImage114.jpg";
import PDFViewerImage115 from "../../../../assets/PDFViewerImages/PDFViewerImage115.jpg";
import PDFViewerImage116 from "../../../../assets/PDFViewerImages/PDFViewerImage116.jpg";


const Chapter32 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 32 */}
                <section id="section32" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter32Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32Paragraph1} </p>
                    <ol className="drivers-handbook-list">
                        <li>{language.chapter32List11}</li>
                        <li>{language.chapter32List12}</li>
                    </ol>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32Paragraph2}</p>

                    <h3 className="drivers-handbook-subheading">{language.chapter32Title2}</h3>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter32Paragraph3}</p>

                    <h3 className="drivers-handbook-subheading"> {language.chapter32ThreadWearTitle}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32ThreadWearParagraph}</p>

                    <h3 className="drivers-handbook-subheading">{language.chapter32TemperatureTitle}</h3>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter32TemperatureParagraph}</p>
                    <ol className="drivers-handbook-list">
                        <li>{language.chapter32TemperatureList11}</li>
                        <li>{language.chapter32TemperatureList12}</li>
                        <li>{language.chapter32TemperatureList13}</li>
                    </ol>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter32TemperatureNote}</p>

                    <h3 className="drivers-handbook-subheading">{language.chapter32LoadSpeedTitle}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter32LoadSpeedList1}</li>
                        <li>{language.chapter32LoadSpeedList2}</li>

                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter32LoadParagraph}</p>

                    <div className="image-box">
                        <img src={PDFViewerImage106} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage107} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage108} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage109} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32SpeedParagraph}</p>

                    <div className="image-box">
                        <img src={PDFViewerImage110} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage111} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage112} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter32ManufactureTitle}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32ManufactureParagraph1}</p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32ManufactureParagraph2}</p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32ManufactureParagraph3}</p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32DateCodeParagraph}</p>

                    <div className="image-box">
                        <img src={PDFViewerImage113} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter32DateCodeParagraph2}</p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32DateCodeParagraph3}</p>

                    <div className="image-box">
                        <img src={PDFViewerImage114} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                        {language.hapter32DateCodeParagraph4}</p>

                    <div className="image-box">
                        <img src={PDFViewerImage115} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading"> {language.chapter32AirPressureTitle} </h3>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter32AirPressureParagraph}</p>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter32AirPressureList1}</li>
                        <li>{language.chapter32AirPressureList2}</li>
                        <li>{language.chapter32AirPressureList3}</li>
                        <li>{language.chapter32AirPressureList4}</li>
                        <li>{language.chapter32AirPressureList5}</li>
                        <li>{language.chapter32AirPressureList6}</li>
                        <li>{language.chapter32AirPressureList7}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                      {language.chapter32RotationTitle}</p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter32RotationParagraph}</p>

                    <div className="image-box">
                        <img src={PDFViewerImage116} alt="Traffic Rules"/>
                    </div>


                </section>
        </>
    )

}

export default Chapter32;
